import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styled from "styled-components";
import theme from "../../styles/theme";

import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Icon, { ClickableIcon } from "../../components/Icon";
import Input, { InputTextArea } from "../../components/Input";
import { StyledText } from "../../components/Text";
import { SaveButton } from "../../components/PillarOverviewModify";
import axios from "axios";
type PillarSubdomainCreateType = {
  currentId?: any;
  isOpen?: boolean;
  header: string;
  mode: "modify" | "create";
  setOpen: (x: boolean) => void;
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
  isErrorOpen: boolean;
  setIsErrorOpen: (x: boolean) => void;
  subdomainData?: {
    id: string;
    description: string;
    title: string;
    knowledge_areas: Array<{
      id: string;
      description: string;
      title: string;
      knowledge_topics: Array<{
        id: string;
        description: string;
        title: string;
      }>;
    }>;
  };
  onSaveComplete: () => void;
};

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
interface SkillwInputs {
  title: string;
  description: string;
}

const SubdomainCreate = ({
  isOpen,
  setOpen,
  header,
  mode,
  subdomainData,
  currentId,
  onSaveComplete,
  isSnackbarOpen,
  setIsSnackbarOpen,
  setMessage,
  setIsErrorOpen,
  isErrorOpen

}: PillarSubdomainCreateType): JSX.Element => {
  const [count, setCount] = useState({ name: 0, description: 0 });

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<SkillwInputs>({
    mode: "onBlur",
    defaultValues: {
      title: subdomainData ? subdomainData.title : "",
      description: subdomainData ? subdomainData.description : "",
    },
  });

  const createSubdomain = (data: any) => {
    axios
      .post("/subdomain/new", { ...data, pillar_id: currentId.pillar_id })
      .then((res: any) => {
        setIsSnackbarOpen(true);
        setMessage("Created Subdomain Successfully!");
        onSaveComplete();
      })
      .catch((err) => {
        setIsErrorOpen(true);
        setMessage(err?.response?.data?.error);
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit(createSubdomain)}>
        {/* <CustomFlex>
          <FlexGrow>
            <Header>{header}</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color="black"
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex> */}
        <CustomFlex
          style={{
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 15,
          }}
        >
          <FlexGrow>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Title<span style={{ color: "red" }}> *</span></Label>
              </CustomGrowPlain>
              <FlexGrow>
                <Input
                  maxLength={64}
                  style={{ width: "100%" }}
                  isFullWidth
                  {...register("title", { required: true })}
                />
                {errors.title && (
                  <p
                    style={{
                      marginTop: 0,
                      color: theme.color.red800,
                    }}
                  >
                    This field is required
                  </p>
                )}
              </FlexGrow>
            </CustomFlexPlain>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Description</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <FlexBox
                  space={0}
                  alignItems="start"
                  style={{ width: "100%" }}
                  direction="column"
                >
                  <FlexGrow style={{ width: "100%" }}>
                    {/* <InputTextArea
                        isFullWidth
                        style={{ minHeight: "100px", width: "100%" }}
                        // onChange={e => setCount(e.target.value.length)}
                        {...register("description")}
                      /> */}
                    <Controller
                      name="description"
                      control={control}
                      render={({ field }) => (
                        <InputTextArea
                          isFullWidth
                          style={{ minHeight: "100px", width: "100%" }}
                          // value={field.value}
                          maxLength={2048}
                          onChange={(e: any) => {
                            field.onChange(e);
                            setCount({
                              ...count,
                              description: e.target.value.length,
                            });
                          }}
                        />
                      )}
                    />
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: "end" }}>
                    <StyledText
                      style={{ fontSize: "14px" }}
                      color={theme.color.lightBlueGray500}
                    >
                      {count.description}/2048
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </FlexGrow>
            </CustomFlexPlain>
            <FlexBox>
              <FlexGrow></FlexGrow>
              <Button
                className="reduce_opct_onhover"
                type="button"
                onClick={() => setOpen(false)}
                style={{
                  border: "2px solid #64748B",
                  padding: "8px 40px",
                  fontSize: "14px",
                }}
              >
                Cancel
              </Button>
              <SaveButton
                className="reduce_opct_onhover"
                style={{
                  padding: "8px 40px",
                  color: "white",
                }}
              >
                <Icon style={{ paddingRight: "8px" }} name={"save"} />
                Save
              </SaveButton>
            </FlexBox>
          </FlexGrow>
        </CustomFlex>
      </form>
    </>
  );
};
export default SubdomainCreate;
